import React, { useEffect } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
} from "@material-ui/core";
export default function AlertDialog({ Alert, setAlertMessage }) {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAlertMessage(false);
  };
  useEffect(() => {
    handleClickOpen();
  }, []);
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ textAlign: "center" }} id="alert-dialog-title">
          <Typography variant="h6">Unable To Upload Excel File</Typography>
        </DialogTitle>
        <DialogContent >
          <DialogContentText id="alert-dialog-description" style={{ textAlign: "center" }}>
            {Alert.map((item, index) => (
              <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              }}
              m={1}
              >
                {index + 1}.{"  "}{item}


             {/* <ul type="none">
                <li>
                  <b>{index + 1}.</b> {"  "}
                  {item}
                </li>
            </ul>*/}
              </Box>

          
            ))}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="error" variant="contained" onClick={handleClose}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
// export default  AlertDialog
